/**
 * 已投递 Page
 */
import spendGameManager from "../../manager/spendGameManager";
import {NpcEventRel, SpendModeAccountBookItemI} from "../../config/SpendInterface";
import O1HD from "../../../../engines/gameEngine";
import InvestmentItem from "./InvestmentItem";
const {ccclass, property} = cc._decorator;
@ccclass
export default class PageHasInvestment extends cc.Component {

    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;
    @property(cc.Node)
    contentNode : cc.Node = null;
    @property(cc.Prefab)
    investmentItem : cc.Prefab = null;

    private mGameLayer : spendGameManager;
    private mDayRecordFlag : boolean;

    onLoad () {
        O1HD.on("Page.refreshData" , this.refreshData , this );
    }

    start () {
        this.refreshData();
    }

    bindData( gameLayer : spendGameManager , dayRecordFlag : boolean = false ){
        this.mGameLayer = gameLayer;
        this.mDayRecordFlag = dayRecordFlag;
        // 加载已投资的数据
        // this.mGameLayer.getGameData()._currentEvents.forEach((value, index, array)=>{
        //     //已经投资过的
        //     if ( value.investCoins > 0 ) {
        //         this.addItem( value );
        //     }
        // });
    }

    //刷新数据
    refreshData(){
        this.contentNode.destroyAllChildren();
        let currDays = this.mGameLayer.getGameData()._gameDays;
        let bookData = this.mGameLayer.getGameData()._account_book[ currDays ] ;
        if ( bookData ){
            for ( let bookItem of bookData ) {
                this.addItem( bookItem );
            }
        }
    }
    /**
     * 添加Item
     * @param itemData
     */
    addItem( itemData : SpendModeAccountBookItemI ){
        let investmentItemNode = cc.instantiate( this.investmentItem );
        this.contentNode.addChild( investmentItemNode  );
        investmentItemNode.getComponent( InvestmentItem ).bindData( itemData , this.mGameLayer , this.mDayRecordFlag );
    }



}
